export default __webpack_public_path__ + "static/media/GothamBlack.c9e42599.otf";